/* istanbul ignore file */

const crnLogoFull = (
  <svg
    width="177"
    height="24"
    viewBox="0 0 177 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>CRN Logo</title>
    <path
      d="M0 12.3794C0 6.61373 4.26248 0.147936 11.3083 0.147936C14.1246 0.128134 16.9101 0.735399 19.4626 1.92569C19.3219 5.39539 18.9409 7.18687 18.0486 9.06071H14.9599C14.2735 6.50734 14.4485 6.91574 13.7038 4.94237C12.8714 4.7746 12.0235 4.69637 11.1744 4.709C10.1895 4.709 8.92307 4.89776 8.50095 5.41255C7.56402 6.58284 6.90852 8.87882 6.90852 11.1302C6.90852 14.4557 8.21953 19.0511 12.5781 19.0511C14.4073 19.0511 16.0924 18.5809 18.7556 17.4553C19.5038 18.1417 19.8333 19.0511 19.974 20.3621C17.7123 22.2188 13.872 24 10.4503 24C3.14024 24 0 18.8933 0 12.3794Z"
      fill="url(#paint0_linear_7697_212115)"
    />
    <path
      d="M46.2287 20.2519C47.242 20.0728 48.2376 19.8052 49.2042 19.4523C49.3338 18.5844 49.3969 17.7078 49.393 16.8303V5.34012C48.1838 4.97912 46.9443 4.7287 45.6899 4.59195C45.3495 3.67782 45.2839 2.68409 45.5011 1.73314C48.2849 0.777258 51.1869 0.209087 54.1256 0.0446154L54.8738 0.418698C55.1781 1.13849 55.4439 1.87397 55.67 2.62201C57.5919 1.12225 59.8879 0 62.8428 0C66.4017 0 70.1974 2.24793 70.1974 7.31006V15.8899C70.1974 17.1529 70.2318 19.3699 70.3382 19.4043C71.8688 19.9019 71.8688 19.9019 73.0837 20.2485C73.0654 21.2972 72.9713 22.3433 72.8023 23.3785C71.5839 23.3304 68.8418 23.2927 66.968 23.2927C64.2979 23.2927 63.2786 23.3853 61.7789 23.3853C61.5626 21.7243 61.5627 21.7243 61.3121 20.2485C62.1907 19.9053 62.1907 19.9053 63.2649 19.4489C63.3644 19.4077 63.4537 17.7638 63.4537 16.8269V10.035C63.4537 6.98745 62.9389 4.73952 59.7506 4.73952C58.6283 4.73952 57.3139 5.25432 56.1436 5.90982V15.8934C56.1436 17.1563 56.1848 19.2979 56.2843 19.4077C56.3838 19.5175 57.156 19.9053 58.6489 20.2519C58.6278 21.3057 58.513 22.3554 58.3057 23.3887C57.132 23.3441 54.7708 23.2961 52.897 23.2961C49.616 23.2961 46.6851 23.3922 46.6851 23.3887C46.4523 22.3565 46.2997 21.3078 46.2287 20.2519Z"
      fill="url(#paint1_linear_7697_212115)"
    />
    <path
      d="M32.8503 15.4163L25.9315 19.3081L25.3035 19.6513L23.0075 20.9555C23.1001 21.937 23.1104 22.2665 23.2614 23.3887C23.2614 23.3887 24.5793 23.351 26.4051 23.3235L32.8503 16.0203V15.4163Z"
      fill="url(#paint2_linear_7697_212115)"
    />
    <path
      d="M26.0238 18.5089L32.85 13.8415V13.3953L26.0994 14.8573V16.8307C26.1029 17.391 26.0777 17.9512 26.0238 18.5089Z"
      fill="url(#paint3_linear_7697_212115)"
    />
    <path
      d="M32.8501 8.58012C32.8501 8.55266 32.8845 8.52864 32.8982 8.50118L23.8344 1.44852C23.5564 1.54119 23.275 1.63728 22.9867 1.74024C22.7216 2.68653 22.787 3.69492 23.172 4.59906C24.3904 4.73977 24.888 4.97314 26.0995 5.34722V6.28758L32.8501 8.64189V8.58012Z"
      fill="url(#paint4_linear_7697_212115)"
    />
    <path
      d="M32.8509 10.1316L26.1003 7.15951V10.1796L32.8509 10.3547V10.1316Z"
      fill="url(#paint5_linear_7697_212115)"
    />
    <path
      d="M32.8509 11.6823L26.1003 10.8998V14.1258L32.8509 11.9877V11.6823Z"
      fill="url(#paint6_linear_7697_212115)"
    />
    <path
      d="M27.3149 3.33977L33.6091 7.46841L27.3286 3.32604L27.3149 3.33977Z"
      fill="url(#paint7_linear_7697_212115)"
    />
    <path
      d="M39.4091 0.147949C38.8109 0.147585 38.2153 0.227226 37.6382 0.384754C35.579 0.944162 34.0209 2.44392 32.8026 4.12901C32.4802 2.86867 32.0731 1.63151 31.5843 0.425937L31.1312 0.192565L30.8327 0.0415588C28.6021 0.170074 26.3988 0.595971 24.2811 1.30795L27.3389 3.3225L33.616 7.4683C34.8343 5.89647 36.1453 5.16203 37.0754 5.16203C37.3416 5.15464 37.6079 5.16956 37.8716 5.20665C38.9012 7.26582 38.9012 7.26582 39.7351 9.7986C41.2795 9.83635 41.2795 9.83635 42.8239 9.7986C42.9028 9.53777 42.9715 9.26664 43.0367 8.99209C43.6064 6.63777 43.7608 3.91966 43.7608 0.896115C42.3721 0.368486 40.8943 0.114432 39.4091 0.147949Z"
      fill="url(#paint8_linear_7697_212115)"
    />
    <path
      d="M32.9909 19.4114C32.9428 18.8623 32.9085 18.3132 32.8879 17.7469L27.4757 23.2827C29.027 23.2827 28.6495 23.3101 29.5349 23.2827H29.5967C31.9784 23.2827 34.0205 23.317 35.6197 23.3616H35.9252V23.2827C36.0625 21.6559 36.0659 21.6285 36.1723 20.2317C34.8819 19.8748 35.0054 19.9811 32.9909 19.4114Z"
      fill="url(#paint9_linear_7697_212115)"
    />
    <path
      d="M27.2465 23.3098H27.2739V23.2823L27.2465 23.3098Z"
      fill="url(#paint10_linear_7697_212115)"
    />
    <path
      d="M88.2723 6.26674C87.7438 8.27444 86.5907 8.92307 85.0566 8.92307C82.7743 8.92307 81.7173 7.22769 81.7173 4.42035C81.7173 1.61302 83.0146 0 85.1149 0C86.7005 0 87.6854 0.744733 88.1419 2.57053L87.0711 2.78674C86.7005 1.51349 86.0621 1.00899 85.1046 1.00899C83.7112 1.00899 82.8567 2.28225 82.8567 4.41006C82.8567 6.7026 83.5671 7.89006 85.0669 7.89006C86.0965 7.89006 86.8206 7.35124 87.181 6.01621L88.2723 6.26674Z"
      fill="#4D646B"
    />
    <path
      d="M89.1886 5.69018C89.1886 3.63101 90.1976 2.41266 91.8415 2.41266C93.4854 2.41266 94.4841 3.62757 94.4841 5.69018C94.4841 7.68414 93.4546 8.92307 91.8415 8.92307C90.2285 8.92307 89.1886 7.68414 89.1886 5.69018ZM93.4648 5.69018C93.4648 4.26248 92.9466 3.26722 91.8415 3.26722C90.7365 3.26722 90.2217 4.26248 90.2217 5.69018C90.2217 7.11787 90.7502 8.06852 91.8415 8.06852C92.9329 8.06852 93.4648 7.1213 93.4648 5.69018Z"
      fill="#4D646B"
    />
    <path
      d="M95.9256 8.92307V0.29858H96.9551V8.92307H95.9256Z"
      fill="#4D646B"
    />
    <path d="M98.7844 8.92307V0.29858H99.814V8.92307H98.7844Z" fill="#4D646B" />
    <path
      d="M105.192 8.78923L105.096 8.04449C104.504 8.58734 103.736 8.89918 102.934 8.92307C101.839 8.92307 101.218 8.26071 101.218 7.25171C101.205 6.89675 101.295 6.54571 101.478 6.24113C101.661 5.93656 101.928 5.69153 102.247 5.53574C103.156 5.13988 104.113 4.86192 105.092 4.70864C105.188 3.61385 104.77 3.25349 103.857 3.25349C103.524 3.2402 103.194 3.32107 102.905 3.4868C102.616 3.65253 102.38 3.8964 102.223 4.19041L101.478 3.72367C101.717 3.30417 102.069 2.96015 102.494 2.7308C102.918 2.50144 103.399 2.39597 103.881 2.42639C105.408 2.42639 106.091 3.08532 106.091 4.45467V7.81799L106.187 8.78923H105.192ZM105.058 5.44994C103.919 5.67988 103.256 5.85834 102.789 6.13633C102.612 6.24123 102.467 6.39261 102.37 6.57409C102.272 6.75557 102.226 6.96023 102.237 7.16592C102.227 7.29447 102.246 7.42363 102.291 7.54416C102.337 7.66469 102.409 7.77361 102.502 7.86312C102.595 7.95264 102.706 8.02055 102.828 8.06199C102.95 8.10343 103.08 8.11738 103.208 8.10284C103.561 8.09041 103.908 8.00431 104.226 7.85006C104.544 7.69581 104.826 7.47681 105.055 7.2071L105.058 5.44994Z"
      fill="#4D646B"
    />
    <path
      d="M107.879 8.77893V0.154438H108.909V3.29124C109.131 3.02769 109.41 2.8166 109.724 2.67303C110.037 2.52946 110.379 2.45696 110.724 2.46071C112.214 2.46071 113.223 3.68592 113.223 5.70391C113.223 7.61207 112.32 8.92307 110.796 8.92307C110.422 8.9332 110.051 8.86097 109.708 8.71151C109.365 8.56205 109.06 8.33902 108.813 8.05822L108.634 8.77893H107.879ZM108.909 7.10757C109.082 7.38416 109.32 7.61357 109.604 7.77527C109.887 7.93698 110.206 8.02594 110.532 8.0342C111.562 8.0342 112.19 7.14532 112.19 5.67988C112.19 4.21444 111.551 3.33929 110.518 3.33929C110.193 3.35259 109.876 3.446 109.595 3.61123C109.314 3.77646 109.078 4.0084 108.909 4.28651V7.10757Z"
      fill="#4D646B"
    />
    <path
      d="M114.197 5.69018C114.197 3.63101 115.206 2.41266 116.85 2.41266C118.494 2.41266 119.493 3.62757 119.493 5.69018C119.493 7.68414 118.463 8.92307 116.85 8.92307C115.237 8.92307 114.197 7.68414 114.197 5.69018ZM118.473 5.69018C118.473 4.26248 117.955 3.26722 116.85 3.26722C115.745 3.26722 115.23 4.26248 115.23 5.69018C115.23 7.11787 115.759 8.06852 116.85 8.06852C117.942 8.06852 118.473 7.1213 118.473 5.69018Z"
      fill="#4D646B"
    />
    <path
      d="M120.924 8.92307V2.70095H121.899V3.87811C122.424 2.94118 123.024 2.5568 123.793 2.5568C123.857 2.55034 123.921 2.55034 123.985 2.5568V3.5658C123.91 3.56028 123.834 3.56028 123.759 3.5658C122.894 3.5658 122.304 4.22817 121.943 5.06899V8.92307H120.924Z"
      fill="#4D646B"
    />
    <path
      d="M128.611 8.78923L128.529 8.0445C127.938 8.5884 127.17 8.90041 126.367 8.92307C125.276 8.92307 124.651 8.26071 124.651 7.25171C124.638 6.89675 124.729 6.54571 124.911 6.24113C125.094 5.93656 125.361 5.69153 125.681 5.53574C126.59 5.13988 127.546 4.86192 128.526 4.70864C128.625 3.61385 128.203 3.25349 127.29 3.25349C126.957 3.24061 126.628 3.32165 126.339 3.48734C126.05 3.65302 125.813 3.89667 125.657 4.19041L124.912 3.72367C125.152 3.30498 125.503 2.96164 125.928 2.73241C126.352 2.50318 126.833 2.39718 127.314 2.42639C128.838 2.42639 129.521 3.08532 129.521 4.45467V7.81799L129.617 8.78923H128.611ZM128.478 5.44994C127.338 5.67988 126.676 5.85834 126.209 6.13633C126.032 6.2418 125.888 6.39329 125.79 6.57463C125.693 6.75597 125.647 6.96034 125.657 7.16592C125.647 7.29479 125.665 7.42429 125.711 7.54509C125.757 7.6659 125.829 7.77501 125.923 7.86459C126.016 7.95418 126.128 8.022 126.25 8.0632C126.373 8.10439 126.503 8.11793 126.631 8.10284C126.984 8.09041 127.331 8.00431 127.649 7.85006C127.967 7.69581 128.249 7.47681 128.478 7.2071V5.44994Z"
      fill="#4D646B"
    />
    <path
      d="M133.897 8.82698C133.585 8.89096 133.268 8.92315 132.949 8.92307C131.92 8.92307 131.542 8.52497 131.542 7.31349V3.43195H130.619V2.60485H131.542V0.54568H132.551V2.60485H133.897V3.43195H132.551V7.26544C132.551 7.79396 132.744 8.0342 133.2 8.0342C133.431 8.03329 133.662 8.00448 133.886 7.9484L133.897 8.82698Z"
      fill="#4D646B"
    />
    <path
      d="M135.17 1.49976V0.26426H136.299V1.49976H135.17ZM135.218 8.92307V2.70095H136.248V8.92307H135.218Z"
      fill="#4D646B"
    />
    <path
      d="M139.364 8.92307L137.25 2.70095H138.355L139.892 7.50568H139.916L141.502 2.70095H142.6L140.431 8.92307H139.364Z"
      fill="#4D646B"
    />
    <path
      d="M145.778 8.92307C144.107 8.92307 143.146 7.66012 143.146 5.66615C143.146 3.67219 144.241 2.41266 145.788 2.41266C147.47 2.41266 148.359 3.61385 148.359 5.43964C148.359 5.53574 148.359 5.65586 148.359 5.81029H144.155C144.217 7.18308 144.683 8.04449 145.85 8.04449C146.215 8.05687 146.574 7.95769 146.881 7.76022C147.188 7.56274 147.427 7.27638 147.566 6.93941L148.345 7.37183C148.117 7.85402 147.752 8.2583 147.295 8.53418C146.839 8.81007 146.311 8.94533 145.778 8.92307ZM144.179 5.05526H147.35C147.35 3.9639 146.773 3.24319 145.788 3.24319C144.803 3.24319 144.316 4.06 144.179 5.05526Z"
      fill="#4D646B"
    />
    <path
      d="M87.229 22.1635L85.4032 18.4536H83.423V22.1635H82.2698V13.5391H84.9433C87.1741 13.5391 88.1591 14.3696 88.1591 15.9414C88.1591 17.1186 87.5241 17.8256 86.5014 18.1619L88.5331 22.1738L87.229 22.1635ZM84.9708 17.4549C85.7155 17.4549 86.9991 17.3348 86.9991 15.9895C86.9991 14.7059 85.9695 14.548 85.0325 14.548H83.423V17.4549H84.9708Z"
      fill="#4D646B"
    />
    <path
      d="M92.1058 22.3077C90.4379 22.3077 89.4769 21.0482 89.4769 19.0542C89.4769 17.0602 90.5683 15.7973 92.1195 15.7973C93.8012 15.7973 94.6866 16.9985 94.6866 18.8243C94.6866 18.9204 94.6866 19.0405 94.6866 19.1983H90.4859C90.5443 20.5711 91.0144 21.4325 92.1779 21.4325C92.5423 21.4444 92.9017 21.3451 93.2082 21.1476C93.5148 20.9502 93.7539 20.6641 93.8938 20.3275L94.6729 20.7599C94.445 21.242 94.0798 21.6461 93.6231 21.9214C93.1664 22.1968 92.6386 22.3311 92.1058 22.3077ZM90.5099 18.4399H93.6811C93.6811 17.3485 93.1045 16.6278 92.1195 16.6278C91.1346 16.6278 90.6301 17.4446 90.5099 18.4399Z"
      fill="#4D646B"
    />
    <path
      d="M99.2305 17.4446C99.0897 17.1851 98.8784 16.9706 98.6209 16.8261C98.3634 16.6815 98.0703 16.6128 97.7754 16.6278C97.1165 16.6278 96.7458 16.971 96.7458 17.4927C96.7458 18.9101 100.215 18.0075 100.215 20.4716C100.215 21.6247 99.2786 22.3077 97.923 22.3077C97.4493 22.3349 96.9772 22.2319 96.558 22.0099C96.1387 21.7879 95.7883 21.4553 95.5446 21.0482L96.2996 20.4956C96.7561 21.182 97.1885 21.4669 97.947 21.4669C98.7638 21.4669 99.2065 21.1237 99.2065 20.5196C99.2065 18.9204 95.7746 19.8813 95.7746 17.527C95.7746 16.4974 96.6154 15.811 97.8337 15.811C98.267 15.779 98.7005 15.8692 99.0851 16.0712C99.4697 16.2732 99.79 16.579 100.01 16.9538L99.2305 17.4446Z"
      fill="#4D646B"
    />
    <path
      d="M103.733 22.3077C102.065 22.3077 101.104 21.0482 101.104 19.0542C101.104 17.0602 102.196 15.7973 103.747 15.7973C105.429 15.7973 106.318 16.9985 106.318 18.8243C106.318 18.9204 106.318 19.0405 106.318 19.1983H102.103C102.161 20.5711 102.632 21.4325 103.795 21.4325C104.159 21.4444 104.519 21.3451 104.825 21.1476C105.132 20.9502 105.371 20.6641 105.511 20.3275L106.293 20.7599C106.066 21.2406 105.701 21.6437 105.246 21.9189C104.791 22.1941 104.265 22.3293 103.733 22.3077ZM102.137 18.4399H105.309C105.309 17.3485 104.732 16.6278 103.747 16.6278C102.762 16.6278 102.258 17.4446 102.137 18.4399Z"
      fill="#4D646B"
    />
    <path
      d="M111.29 22.1635L111.194 21.4188C110.602 21.9617 109.835 22.2735 109.032 22.2974C107.937 22.2974 107.316 21.635 107.316 20.626C107.303 20.2711 107.394 19.92 107.577 19.6155C107.759 19.3109 108.027 19.0658 108.346 18.9101C109.255 18.5144 110.211 18.2354 111.191 18.0795C111.287 16.9882 110.868 16.6278 109.955 16.6278C109.622 16.6141 109.292 16.6948 109.003 16.8606C108.714 17.0264 108.478 17.2705 108.322 17.5647L107.577 17.0946C107.816 16.6709 108.17 16.3235 108.598 16.0922C109.026 15.8609 109.511 15.7551 109.997 15.787C111.524 15.787 112.207 16.4493 112.207 17.8187V21.182L112.303 22.1533L111.29 22.1635ZM111.157 18.8243C110.017 19.0542 109.355 19.2327 108.888 19.5106C108.711 19.6155 108.566 19.7669 108.468 19.9484C108.371 20.1299 108.325 20.3345 108.335 20.5402C108.327 20.6683 108.347 20.7966 108.394 20.9161C108.44 21.0357 108.513 21.1434 108.606 21.2319C108.699 21.3203 108.81 21.3872 108.932 21.4278C109.054 21.4684 109.183 21.4817 109.31 21.4669C109.662 21.457 110.008 21.3741 110.325 21.2235C110.643 21.0728 110.926 20.8577 111.157 20.5917V18.8243Z"
      fill="#4D646B"
    />
    <path
      d="M113.981 22.1635V15.9414H114.956V17.1186C115.488 16.1817 116.081 15.787 116.86 15.787C116.924 15.7805 116.989 15.7805 117.053 15.787V16.8166C116.977 16.811 116.902 16.811 116.826 16.8166C115.961 16.8166 115.371 17.4789 115.011 18.3198V22.1635H113.981Z"
      fill="#4D646B"
    />
    <path
      d="M122.966 20.6981C122.746 21.1917 122.384 21.6086 121.926 21.8953C121.468 22.1821 120.935 22.3257 120.395 22.3077C118.714 22.3077 117.705 21.0585 117.705 19.0782C117.705 17.0191 118.734 15.7973 120.43 15.7973C120.963 15.7634 121.493 15.9131 121.93 16.2214C122.367 16.5298 122.685 16.9784 122.832 17.4927L121.967 17.8359C121.624 17.0293 121.161 16.6827 120.44 16.6827C119.383 16.6827 118.7 17.5716 118.7 19.0851C118.7 20.5986 119.349 21.4394 120.416 21.4394C121.147 21.4394 121.665 21.0962 122.108 20.2485L122.966 20.6981Z"
      fill="#4D646B"
    />
    <path
      d="M128.131 22.1635V18.1413C128.131 17.2764 127.997 16.6861 127.06 16.6861C126.46 16.6861 125.883 17.0293 125.296 17.6368V22.1635H124.267V13.5391H125.296V16.7479C126.065 16.0375 126.669 15.7973 127.338 15.7973C128.059 15.7973 128.515 16.0032 128.814 16.4459C129.092 16.7891 129.14 17.3108 129.14 18.1619V22.1635H128.131Z"
      fill="#4D646B"
    />
    <path
      d="M139.23 22.1635L134.991 14.9221H134.967V22.1635H133.873V13.5391H135.506L139.24 20.0598H139.264V13.5391H140.359V22.1635H139.23Z"
      fill="#4D646B"
    />
    <path
      d="M144.587 22.3077C142.919 22.3077 141.958 21.0482 141.958 19.0542C141.958 17.0602 143.05 15.7973 144.601 15.7973C146.283 15.7973 147.171 16.9985 147.171 18.8243C147.171 18.9204 147.171 19.0405 147.171 19.1983H142.967C143.026 20.5711 143.496 21.4325 144.659 21.4325C145.024 21.4444 145.383 21.3451 145.69 21.1476C145.996 20.9502 146.235 20.6641 146.375 20.3275L147.154 20.7599C146.926 21.242 146.561 21.6461 146.104 21.9214C145.648 22.1968 145.12 22.3311 144.587 22.3077ZM142.991 18.4399H146.162C146.162 17.3485 145.586 16.6278 144.601 16.6278C143.616 16.6278 143.111 17.4446 142.991 18.4399Z"
      fill="#4D646B"
    />
    <path
      d="M151.207 22.1635C150.895 22.229 150.576 22.2612 150.257 22.2596C149.227 22.2596 148.853 21.865 148.853 20.6501V16.7822H147.926V15.9414H148.853V13.8822H149.862V15.9414H151.207V16.7822H149.862V20.5917C149.862 21.1202 150.054 21.3605 150.511 21.3605C150.742 21.359 150.972 21.3313 151.197 21.2781L151.207 22.1635Z"
      fill="#4D646B"
    />
    <path
      d="M156.935 22.1635L155.7 17.6128H155.676L154.427 22.1635H153.428L151.664 15.9414H152.693L153.926 20.5917H153.95L155.199 15.9414H156.197L157.416 20.5917H157.44L158.73 15.9414H159.76L157.934 22.1635H156.935Z"
      fill="#4D646B"
    />
    <path
      d="M160.302 19.0782C160.302 17.019 161.308 15.7973 162.955 15.7973C164.602 15.7973 165.598 17.0122 165.598 19.0782C165.598 21.0722 164.568 22.3077 162.955 22.3077C161.342 22.3077 160.302 21.0722 160.302 19.0782ZM164.575 19.0782C164.575 17.6471 164.06 16.6518 162.955 16.6518C161.85 16.6518 161.332 17.6471 161.332 19.0782C161.332 20.5093 161.86 21.4566 162.955 21.4566C164.05 21.4566 164.565 20.5059 164.565 19.0782H164.575Z"
      fill="#4D646B"
    />
    <path
      d="M167.029 22.1635V15.9414H167.997V17.1186C168.525 16.1817 169.126 15.7973 169.894 15.7973C169.958 15.7909 170.023 15.7909 170.087 15.7973V16.8166C170.01 16.811 169.933 16.811 169.857 16.8166C168.992 16.8166 168.405 17.4789 168.045 18.3198V22.1635H167.029Z"
      fill="#4D646B"
    />
    <path
      d="M175.121 22.1635L173.323 18.9821L172.194 20.2485V22.1807H171.185V13.5391H172.194V18.9444H172.218L174.785 15.9414H175.938L173.992 18.1893L176.25 22.1635H175.121Z"
      fill="#4D646B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7697_212115"
        x1="0"
        y1="12"
        x2="73.0837"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7697_212115"
        x1="0"
        y1="12"
        x2="73.0837"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_7697_212115"
        x1="0"
        y1="12"
        x2="73.0837"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_7697_212115"
        x1="0"
        y1="12"
        x2="73.0837"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_7697_212115"
        x1="0"
        y1="12"
        x2="73.0837"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_7697_212115"
        x1="0"
        y1="12"
        x2="73.0837"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_7697_212115"
        x1="0"
        y1="12"
        x2="73.0837"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_7697_212115"
        x1="0"
        y1="12"
        x2="73.0837"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_7697_212115"
        x1="0"
        y1="12"
        x2="73.0837"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_7697_212115"
        x1="0"
        y1="12"
        x2="73.0837"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_7697_212115"
        x1="0"
        y1="12"
        x2="73.0837"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset="1" stopColor="#0C8DC3" />
      </linearGradient>
    </defs>
  </svg>
);

export default crnLogoFull;
